export const FAQ_ITEMS = [
  {
    q: "Do you manufacture products?",
    a: ["Yes. Manufacturing is done through our licensed manufacturing partners. However, clients may also choose to engage us solely for formulation development."],
  },
  {
    q: "Can I develop an exclusive formulation?",
    a: ["Yes. We specialize in developing custom formulations tailored exclusively to your brand."],
  },
  {
    q: "What is the minimum order quantity?",
    a: ["Our standard commercial MOQ is 1,000 units, although this may vary depending on the product category and manufacturing requirements."],
  },
  {
    q: "Can you assist with packaging?",
    a: ["Yes. We provide packaging guidance to ensure compatibility with the formulation and alignment with your brand positioning."],
  },
  {
    q: "Can you reformulate an existing product?",
    a: ["Yes. We offer reformulation services to improve performance, optimize cost or adapt products to changing market requirements."],
  },
  {
    q: "Can you sign a Non-Disclosure Agreement (NDA)?",
    a: ["Absolutely. We respect client confidentiality and are happy to execute NDAs before project discussions."],
  },
  {
    q: "Who owns the formulation?",
    a: [
      "For stock formulations, the formulation remains the intellectual property of The Formulation House.",
      "For custom formulations, clients have the option to acquire the formulation's intellectual property under mutually agreed commercial terms.",
    ],
  },
  {
    q: "Can you help source ingredients?",
    a: ["Yes. We can assist in identifying as well as sourcing suitable ingredients through our supplier network."],
  },
];

// Homepage keeps a focused 5–7 question subset; the full list lives on /faq
export const HOME_FAQ_ITEMS = FAQ_ITEMS.filter(({ q }) => q !== "Can you help source ingredients?");
